import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatINR } from "@/lib/api";
import { grams, fmtDate } from "@/pages/admin/suppliers/supplierHelpers";

// One side (gold or rupee) of a supplier's dual-currency statement.
export function StatementTable({ entries, unit }) {
  if (!entries || entries.length === 0) {
    return <div className="py-10 text-center text-sm text-muted-foreground">No {unit === "gold" ? "gold" : "rupee"} transactions yet.</div>;
  }
  const fmt = unit === "gold" ? grams : formatINR;
  return (
    <div className="rounded-lg border border-border overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow><TableHead className="w-28">Date</TableHead><TableHead>Description</TableHead><TableHead className="text-right">Debit</TableHead><TableHead className="text-right">Credit</TableHead><TableHead className="text-right">Balance</TableHead></TableRow>
        </TableHeader>
        <TableBody>
          {entries.map((e) => (
            <TableRow key={e.id} data-testid="supplier-ledger-row">
              <TableCell className="text-xs text-muted-foreground whitespace-nowrap">{fmtDate(e.date)}</TableCell>
              <TableCell className="text-sm">
                <div>{e.description}</div>
                {e.ref_no && <div className="text-[11px] text-muted-foreground">{e.ref_no}</div>}
              </TableCell>
              <TableCell className="text-right font-mono text-sm text-[#7A1F1F]">{e.debit ? fmt(e.debit) : "—"}</TableCell>
              <TableCell className="text-right font-mono text-sm text-[#1F5B2E]">{e.credit ? fmt(e.credit) : "—"}</TableCell>
              <TableCell className="text-right font-mono text-sm font-medium">{fmt(e.balance)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
